import { IndividualDeductionsReportStatus } from '@aslanpay/portal-common-lib';

export const IndividualDeductionsReportsStatusValues: Record<
  IndividualDeductionsReportStatus,
  { color: string; value: string }
> = {
  IN_PROGRESS: { color: 'created', value: 'In progress' },
  PROCESSING: { color: 'invited', value: 'Processing' },
  PROCESSED: { color: 'active', value: 'Processed' },
  FAILED: { color: 'left', value: 'Failed' },
};

export default IndividualDeductionsReportsStatusValues;
